import { useFetchWrapper } from "_helpers";
import { paymentsAtom } from "_state";
import { useResetRecoilState, useSetRecoilState } from "recoil";

export { useExtraActions };

function useExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/eInvoice/api/v4`;
    const fetchWrapper = useFetchWrapper();
    const setPayments = useSetRecoilState(paymentsAtom);

    return {
        getAllPayments,
        resetPayments: useResetRecoilState(paymentsAtom)
    }

    function getAllPayments(userAtom) {
        return fetchWrapper
            .get(`${baseUrl}/ComplementoPago/${userAtom.uuid}`)
            .then(setPayments);
    }
}